import { announce } from '@react-aria/live-announcer';
import { useId } from '@react-aria/utils';
import { ReactElement, useEffect } from 'react';

import { Circle1, Circle2, Wrapper } from './styles';
import { LoaderProps } from './types';

const LOADER_LOG_AFTER_MS = 3000;

const Loader = ({
	color = 'white',
	className,
	announcement = 'Loading',
	title = 'Loading spinner',
	description = 'Two circles spinning around',
	context,
	logDelay = LOADER_LOG_AFTER_MS,
	logger,
}: LoaderProps): ReactElement => {
	const titleId = useId();
	const descriptionId = useId();

	useEffect(() => {
		if (!logger) return;

		const timeoutId = setTimeout(() => {
			logger('Loading is taking a while', {
				...context,
				timeOnScreen: logDelay,
			});
		}, logDelay);

		return () => {
			if (timeoutId) {
				clearTimeout(timeoutId);
			}
		};
	}, [context, logDelay, logger]);

	useEffect(() => {
		announce(announcement, 'polite');
	}, [announcement]);

	return (
		<Wrapper
			viewBox="0 0 100 50"
			color={color}
			data-testid="loader"
			role="status"
			aria-labelledby={titleId}
			aria-describedby={descriptionId}
			className={className}
		>
			<title id={titleId}>{title}</title>
			<desc id={descriptionId}>{description}</desc>
			<Circle1 cx="25" cy="25" r="10" />
			<Circle2 cx="75" cy="25" r="10" />
		</Wrapper>
	);
};
export default Loader;
